<template>
  <div>
    <div class="bannerBox">
      <div v-if="topMsg.columnCover" class="imgBox">
        <img :src="topMsg.columnCover" alt="">
        <p>{{ topMsg.columnName }}</p>
      </div>
    </div>
    <div class="w1200 newsBox">
      <div class="leftBox">
        <div v-if="!topMsg.columnCover" class="crumbs">
          <span class="el-icon-location" /><span class="lanmu" @click="gohome">首页</span><span>/{{ topMsg.columnName }}</span>
        </div>
        <div>
          <Firstcolumn v-show="newsIinitData.length" :initdata="newsIinitData" :alldata="alldata" :columnlist="Alltemplate" :column-name="columnId" />
        </div>
      </div>
      <div class="rightBox">
        <Rightlist />
      </div>
    </div>
  </div>
</template>
<script>
import Firstcolumn from '@/views/firstlist/firstcolumn_columnView'
import Rightlist from '@/components/commonRightList'
import { getColumnData, getColumnTopMessage } from '@/api/api.js'
export default {
  components: { Firstcolumn, Rightlist },
  head() {
    var listObj = this.$store.state.clolumninit
    var metaStr = this.initdata
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: metaStr.columnName + '-彭祖世家网_寻根问祖_家谱百科_家谱制作领导者',
      mateDesc: metaStr.columnAbstract,
      keys: '族谱,家族,编谱,族谱查询,族谱app,族谱在线制作,寻根问祖,百家姓,姓氏源流'
    }
  },
  data() {
    return {
      Alltemplate: [{ 'name': '全部', 'value': '' }, { 'name': '资讯', 'value': 'NEWS' }, { 'name': '文库', 'value': 'DOC' }, { 'name': '图集', 'value': 'PHOTO' }, { 'name': '视频', 'value': 'VIDEO' }],
      columnId: this.$route.query.columnId,
      topMsg: ''
    }
  },
  computed: {
    newsIinitData() {
      return this.$store.state.columnData.listMapData
    },
    alldata() {
      return this.$store.state.columnData
    },
    initdata() {
      return this.$store.state.clolumninit
    }
  },
  asyncData({ store, route }) {
    store.dispatch('getColumnTopMessage', { columnId: route.query.columnId })
    return store.dispatch('getColumnData', { columnId: route.query.columnId, index: '1', size: '9' })
  },
  mounted() {
    this.fn()
    getColumnTopMessage({ 'columnId': this.$route.query.columnId }).then(res => {
      this.topMsg = res.data
    })
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    gohome: function() {
      this.$router.push({ path: '/home' })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .bannerBox{
    width: 100%;
    overflow: hidden;
    .imgBox{
      height: 300px;
      font-size: 0;
      text-align: center;
      img{
        height: 300px;
      }
    }
  }
  .crumbs{
    height: 40px;
    line-height: 40px;
    border: 1px solid #e5e5e5;
    padding-left: 10px;
    color: #808080;
    background-color: #fff;
    margin-bottom: 20px;
    .lanmu{
      color: #ed4040;
      cursor: pointer;
      margin-left: 3px;
      margin-right: 5px;
    }
  }
    .newsBox{
        background-color: #fafafa;
        overflow: hidden;
        position: relative;
    }
    .leftBox{
        width: 880px;
        margin-right: 20px;
        margin-top: 20px;
        float: left;
    }
    .rightBox{
        width: 300px;
        /*margin-left: 20px;*/
        margin-top: 20px;
        float: right;
        /*top: 0;*/
        /*right: 0;*/
        overflow: hidden;
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .leftBox{
      width: 100%;
      margin-top: 0;
    }
    .crumbs{
      margin: 20px auto;
    }
    .rightBox{
      display: none;
    }
  }
</style>

